export default __webpack_public_path__ + "static/media/ig1.46e804fe.jpg";